<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目进度款审核意见单</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <create-money-approval
            v-if="form"
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          ></create-money-approval>

          <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments
                :projectId="form.projectId"
                :contractId="form.contractId"
                ref="attachments"
                :arr="attachmentArr"
                :type="5"
              ></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
          <div class="clear label-mx">
            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item
              ref="approval"
              :approvalUsers="approvalUsersData"
              :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"
            ></approval-item>
          </div>

          <div class="tip tip-table">
            <p>
              <span class="tip-lable">注：</span
              >1、本表作为进度款审核意见单，附有工程量支付清单；
            </p>
            <p>2、本表为进度款审批流程表，进度款支付金额需与本表一致。</p>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="createProject()"
                class="form-btn"
                type="success"
                >确认提交项目进度款审核意见单</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import approvalUsers from "@/Mixins/approvalUsers";

import ApprovalItem from "@/components/ApprovalItem";
import CreateMoneyApproval from "@/page/form/createMoneyApproval";

import ObjectUtil from "../mixins/objectUtil";
export default {
  components: {
    ApprovalItem,
    CreateMoneyApproval,
    Attachments,
  },
  mixins: [approvalUsers, ObjectUtil],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      project: {},
      form: {
        projectId: "",
        sstime: "",

        jbzf: "0,0,0,0",
        azf: "0,0,0,0",
        bxfxm: "0,0,0,0",
        zlj: "0,0,0,0",
        gcbg: "0,0,0,0",
        jgtz: "0,0,0,0",
        gcyfk: "0,0,0,0",
        xj: "0,0,0,0",
        kkxm: "0,0,0,0",
        hkgcyfk: "0,0,0,0",
        blj: "0,0,0,0,5",
        htnkk: "0,0,0,0,1",
        bgkk: "0,0,0,0,2",
        yk: "0,0,0,0,22.5",
        sjzf: "0,0,0,0",

        // 是否线下审批通过
        underLine: "",

        // 类型 2021-2-4
        type: 0,
      },

      // 附件
      attachmentArr: [],
      // 审批
      approvalType: "0",
      formLoading: false,
      approvalUsersData: [],

      applyInfo: "",
    };
  },
  created() {
    // this.setSelectArr(this.applyInfo, 5)
  },
  mounted() {
    this.form.projectId = this.$route.params.projectId;
    this.form.sstime = util.getFormatDate();
    this.getProject();

    this.getApplyData();
  },
  methods: {
    // 获取审批表原内容
    getApplyData() {
      this.form.approvalId = this.$route.params.applyId;
      if (this.form.approvalId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
      } else {
        this.setSelectArr(this.applyInfo, 5, this.form.type);
      }
    },
    // 获取原审批表内容
    getProjectApplyInfo() {
      ajax.get(
        "/gc/project/money/approval/info/" + this.form.approvalId,
        "",
        (res) => {
          this.applyInfo = res.vo;

          this.form.sstime = this.applyInfo.sstime;

          this.form.jbzf = this.applyInfo.jbzf;
          this.form.azf = this.applyInfo.azf;
          this.form.bxfxm = this.applyInfo.bxfxm;
          this.form.gcbg = this.applyInfo.gcbg;
          this.form.jgtz = this.applyInfo.jgtz;
          this.form.gcyfk = this.applyInfo.gcyfk;
          this.form.xj = this.applyInfo.xj;
          this.form.kkxm = this.applyInfo.kkxm;
          this.form.hkgcyfk = this.applyInfo.hkgcyfk;
          this.form.blj = this.applyInfo.blj;
          this.form.yk = this.applyInfo.yk;
          this.form.sjzf = this.applyInfo.sjzf;

          // 是否线下通过审批
          this.form.underLine = this.applyInfo.underLine.toString();

          this.attachmentArr = this.applyInfo.attachments
            ? this.applyInfo.attachments
            : [];

          this.form.type = this.applyInfo.type / 1;

          this.setSelectArr(this.applyInfo, 5, this.form.type);
          this.formLoading = false;
        }
      );
    },
    // 获取所有项目
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;

        if (this.project.type == 1 || this.project.type == 4) {
          this.form.type = 1;
        }

        // 修改当前选中的侧边栏
        this.setNavType(this.project);
      });
    },
    // 提交
    createProject() {
      this.form = this.$refs.create.getFromData();
      if (this.form.underLine == "") {
        this.$message.error("请标注本次审批是否已线下通过");
        return;
      }

      // 赋值合同ID
      this.form.contractId = this.project.contractId;

      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      this.form.attachments = this.$refs.attachments.getAttachments();

      this.formLoading = true;
      let _url = !this.form.approvalId
        ? "/gc/project/money/approval"
        : "/gc/project/money/approval/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.$message.success(
            "提交项目进度款审核意见单成功，请耐心等待领导审批"
          );
          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {
    "form.type"() {
      if (this.form.type == 1 || this.form.type == 4) {
        // 原水
        this.approvalUsersData = this.approvalUsers.c5_1;
      } else {
        // 其他
        this.approvalUsersData = this.approvalUsers.c5_0;
      }
    },
    // approvalUsers.c5
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createMoneyApproval.vue